// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 61) return "61." + __webpack_require__.h() + ".min.css";
	// return url for filenames based on template
	return "" + "index" + "." + __webpack_require__.h() + ".min.css";
};